import Vue from 'vue';
import Component from 'vue-class-component';
import { Async } from '@/utils/AsyncDecorators';
import { areaSaggioClasseDiametricaStore } from '../../store/areaSaggioClasseDiametrica.store';
import { store } from '@/store';

@Component({})
export default class DashboardItem extends Vue{
    
    @Async({ async get() { return await areaSaggioClasseDiametricaStore.getters.getAll() }, default: [], lazy: true })
    areeSaggioClasseDiametrica: server.areaSaggioClasseDiametrica[];

    get numeroTotale(){
        return [...new Set(this.areeSaggioClasseDiametrica.map(f => f.areaSaggioId))].length;
    }
    
    goTo(routeName) {
        store.actions.ui.toggleDrawerMenu(false);
        store.actions.ui.toggleUserMenu(false);
        this.$router.push({ name: routeName })
    }

}